import HTTP from '../http'
import { jsonp } from 'vue-jsonp'
const BASE_URL = '/tsg-author/web'
// const imgUrl = location.host.indexOf("dev.") != -1 || location.host.indexOf("test") != -1|| location.host.indexOf(":80") != -1 ? 'https://fdfs.cnknowledge.com/' : "https://kpp.cnknowledge.com/"
const imgUrl=process.env.VUE_APP_API_IMG_URL;
export default {
  imgUrl,
  //  一级菜单

  findOne() {
    return HTTP.get(BASE_URL + '/encyclopedia/findOneList')
  },
  // 最新期刊列表
  periodNewestList() {
    return HTTP.get(BASE_URL + '/encyclopedia/periodNewestList')
  },

  // 获取核心期刊列表
  periodCore() {
    return HTTP.get(BASE_URL + '/encyclopedia/periodCoreList')
  },

  // 获取文献推荐
  paperDocument() {
    return HTTP.get(BASE_URL + '/paper/paperDocumentList')
  },

  // 获取最新文献
  paperNewest() {
    return HTTP.get(BASE_URL + '/encyclopedia/queryNewReadList')
  },

  // 热门期刊
  periodHot() {
    return HTTP.get(BASE_URL + '/encyclopedia/periodHotList')
  },

  // 下载排行
  paperDownload() {
    return HTTP.get(BASE_URL + '/paper/paperDownloadList')
  },
  // 阅读排行
  periodRead() {
    return HTTP.get(BASE_URL + '/paper/readArticleList')
  },
  // ip获取
  getUserIpConfig() {
    return new Promise((resolve, reject) => {
      jsonp(`https://apis.map.qq.com/ws/location/v1/ip?key=OWOBZ-6CZKQ-44B5T-2WQIO-YUTJ7-5TFJO`, {
        output: 'jsonp',
      }).then(resp => {
        resolve(resp)
      }).catch(err => {
        console.log(err);
      })
    })
  },
}